import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-filter",
  "use": "icon-filter-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-filter\"><path d=\"M12.6 3c.2 0 .4.2.4.5 0 .2-.1.3-.1.3L9.3 7.3l-.3.3V13H7V7.6l-.3-.3-3.5-3.5c-.1-.1-.2-.2-.2-.3 0-.3.3-.5.5-.5zm0-1H3.5C2.7 2 2 2.6 2 3.5c0 .4.2.8.5 1L6 8v6h4V8l3.6-3.5c.3-.3.4-.6.4-1 0-.9-.6-1.5-1.4-1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol